module.exports = __webpack_public_path__ + "img/white-logo.a48eaeca.png";